import { ReactElement } from 'react'
import classNames from 'classnames'

/**
 * Placeholder rows for the inbox conversation list, shown while the first sync
 * is in flight (initial load or after switching locations). Mirrors the layout
 * of <Conversation> so the list doesn't pop from empty to populated with no
 * loading transition.
 */
export function ConversationListSkeleton({ compact, rows = 6 }: { compact?: boolean; rows?: number }): ReactElement {
  return (
    <div aria-hidden className="flex flex-col">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className={classNames(
            `flex w-full items-start gap-x-3 border-b border-subtle px-4 py-4`,
            compact ? `justify-center` : ``,
          )}
        >
          <div className="h-9 w-9 shrink-0 animate-pulse rounded-full bg-surface-muted" />
          {!compact && (
            <div className="flex min-w-0 flex-1 flex-col gap-y-2 pt-0.5">
              <div className="flex items-center justify-between gap-x-2">
                <div className="h-3.5 w-28 animate-pulse rounded bg-surface-muted" />
                <div className="h-3 w-10 animate-pulse rounded bg-surface-muted" />
              </div>
              <div className="h-3 w-3/4 animate-pulse rounded bg-surface-muted" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
